const SDK_VERSION = '7.84.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
